import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function HotRecommendSection() {
  const hotComics = comics.sort((a, b) => b.rating - a.rating).slice(0, 6);

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              <i className="ri-fire-line text-accent-500 mr-2"></i>
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-2">评分最高的韩国漫画精选</p>
          </div>
          <Link
            to="/category/all"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium flex items-center gap-1 whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-6">
          {hotComics.map((comic, idx) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group"
            >
              <div className="relative aspect-[3/4] rounded-lg overflow-hidden mb-3 bg-background-100">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute top-2 left-2">
                  <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${
                    idx === 0 ? 'bg-primary-500 text-background-50' :
                    idx === 1 ? 'bg-accent-500 text-background-50' :
                    'bg-secondary-500 text-background-50'
                  }`}>
                    TOP {idx + 1}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-3">
                  <div className="flex items-center gap-1 text-xs text-white/90">
                    <i className="ri-star-fill text-accent-400 text-xs"></i>
                    <span>{comic.rating}</span>
                    <span className="mx-1">·</span>
                    <span>{comic.category}</span>
                  </div>
                </div>
              </div>
              <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
                {comic.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-1">{comic.author}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}